import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, NavLink } from 'react-router-dom';
import { useSearchContext } from './SearchContext';
import axios from 'axios';
import "@fortawesome/fontawesome-free/css/all.min.css";

function Navbar() {
    const navigate = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const searchMode = params.get('smode') || 'keyword';
    const currentSort = params.get('sort') || 'relevance';
    const { isDocumentLoaded } = useSearchContext();
    const { numResults } = useSearchContext();
    const { setSearchData } = useSearchContext();
    const { baseUrl } = useSearchContext();
    const apiUrl = `${baseUrl}/brockden.php`;
    const isCitationTabWorking = true;

    const [sortOption, setSortOption] = useState(currentSort);
    const { currentPage, setCurrentPage, processedMetadata, isPrintView, builtCitationContent } = useSearchContext();
    const resultsPerPage = 20;
    const totalPages = Math.ceil(processedMetadata.length / resultsPerPage);
    const maxVisiblePages = 5;

    const currentGroup = Math.floor((currentPage - 1) / maxVisiblePages);
    const startPage = currentGroup * maxVisiblePages + 1;
    let endPage = Math.min(startPage + maxVisiblePages - 1, totalPages);

    const goToNextGroup = () => {
        const nextGroupStart = endPage + 1;
        if (nextGroupStart <= totalPages) {
            setCurrentPage(nextGroupStart);
        }
    };

    const goToPrevGroup = () => {
        const prevGroupStart = Math.max(1, startPage - maxVisiblePages);
        setCurrentPage(prevGroupStart);
    };
    
    const { USE_HASH_ROUTER } = useSearchContext();

    const currentPath = USE_HASH_ROUTER
        ? window.location.hash.replace(/^#/, '') // remove the leading #
        : location.pathname + location.search;

    const match = currentPath.match(/view-document\/(\d{4}-[\w\d]+)/);
    //const accessionNumber = match ? match[1] : null;
    //const year = accessionNumber ? accessionNumber.split('-')[0] : 'Unknown Date';

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const urlSort = params.get('sort') || 'relevance';
        setSortOption(urlSort);
    }, [location.search]);

    const handleModifySearch = () => {
        if (searchMode === 'advanced') {
            navigate(`/advanced-search?${params.toString()}`);
        } else {
            navigate(`/search?${params.toString()}`);
        }
    };

    const handleNewSearch = () => {
        setSearchData([]);
        localStorage.removeItem('searchData');
        navigate('/search');
    };
    const handleBrowseChronological = () => {
        navigate(`/searchresults?keyword=brown&browse=true&smode=keyword&sort=date`);
    }
    const handleBrowseTitle = () => {
        navigate(`/searchresults?keyword=brown&browse=true&smode=keyword&sort=title`);
    }

    const handleSortChange = (event) => {
        setSortOption(event.target.value);
    };

    const handleApplySort = () => {
        const searchParams = new URLSearchParams(location.search);
        searchParams.set('sort', sortOption);

        navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true });
    };

    const isSearchResultsPage = location.pathname === '/searchresults';
    const isViewDocumentPage = location.pathname.startsWith('/view-document');

    const handleRemoveQuery = (param) => {
        const newParams = new URLSearchParams(location.search);

        // Handle special cases where both related params should be removed
        if (param === 'fromYear' || param === 'toYear') {
            newParams.delete('fromYear');
            newParams.delete('toYear');
        } else if (param === 'genre') {
            newParams.delete('genre');
        } else {
            newParams.delete(param);
        }

        const visibleParams = ['keyword', 'title', 'author', 'genre', 'fromYear', 'toYear', 'entireText', 'excludeText'];

        const hasRemainingFilters = visibleParams.some((p) => {
            const value = newParams.get(p);
            return value && value.trim() !== '';
        });

        if (!hasRemainingFilters) {
            setSearchData([]);
            localStorage.removeItem('searchData');
            navigate('/search');
            return;
        }

        navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });

        const requestData = {
            documentInfo: {
                Sort: newParams.get('sort') || 'relevance',
            },
        };

        if (searchMode === 'keyword') {
            requestData.documentInfo.Keyword = newParams.get('keyword') || '';
        } else if (searchMode === 'advanced') {
            requestData.documentInfo = {
                Title: newParams.get('title') || '',
                Author: newParams.get('author') || '',
                Genre: newParams.get('genre') || '',
                FromYear: newParams.get('fromYear') || '',
                ToYear: newParams.get('toYear') || '',
                Type: newParams.get('type') || '',
                EntireText: newParams.get('entireText') || '',
                ExcludeText: newParams.get('excludeText') || '',
                Section: newParams.get('section') || '',
                Sort: newParams.get('sort') || 'relevance',
            };
        }

        axios.post(apiUrl, requestData)
            .then((response) => {
                console.log('Updated Search Results:', response.data);
                setSearchData(response.data);
                navigate(`/searchresults?${newParams.toString()}`);
            })
            .catch((error) => {
                console.error('Error fetching updated search results:', error);
            });
    };

    const getSearchDescription = (params) => {
        const browse = params.get('browse') === 'true';
        const keyword = params.get('keyword') || '';
        const sort = params.get('sort') || 'relevance';
        const filterDefaults = true;

        // Special case for browse=true and keyword=brown
        if (browse && keyword.toLowerCase() === 'brown' && (sort === 'date' || sort === 'title')) {
            let browseLabel = 'Browse by: ';
            browseLabel += sort === 'date' ? 'All' : 'Title';

            return (
                <div className="search-query">
                    {browseLabel}
                </div>
            );
        }

        // Default search description
        const fieldMapping = {
            keyword: "in keywords",
            title: "in title",
            author: "as author",
            genre: "in genre",
            fromYear: "from year",
            toYear: "to year",
            type: "as type",
            entireText: "in the full text",
            excludeText: "excluded from text",
            section: "in section",
        };

        return Object.entries(fieldMapping)
            .map(([param, label]) => {
                const value = params.get(param);
                if (!value || !value.trim()) return null;

                if (filterDefaults && ((param === "type" && value === "all") || (param === "section" && value === "any"))) {
                    return null;
                }

                return (
                    <div key={param} className="search-query">
                        {value} {label}{" "}
                        <span onClick={() => handleRemoveQuery(param)} className="remove-query">
                            [X]
                        </span>
                    </div>
                );
            })
            .filter(Boolean);
    };

    return (
        <>
            {!(isViewDocumentPage && isPrintView) && (
                <nav className="navbar navbar-expand-lg navbar-light">
                    <div className="container">
                        <button
                            className="navbar-toggler"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#navbarNavDropdown"
                            aria-controls="navbarNavDropdown"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                        >
                            <span className="sr-only">Toggle navigation</span>
                            <span className="fa fa-arrow-down"></span>
                            <span className="toggler-text">MENU</span>
                        </button>

                        <div className="collapse navbar-collapse" id="navbarNavDropdown">
                            <ul className="navbar-nav mx-auto">
                                <li className="nav-item">
                                    <NavLink className="nav-link" to="/">
                                        Home
                                    </NavLink>
                                </li>
                                <li className="nav-item dropdown">
                                    <NavLink
                                        to="/about"
                                        className={({ isActive }) =>
                                            isActive ||
                                                window.location.pathname.includes('/about') ||
                                                window.location.pathname.includes('/support') ||
                                                window.location.pathname.includes('/participants') ||
                                                window.location.pathname.includes('/affiliation') ||
                                                window.location.pathname.includes('/partners')
                                                ? "nav-link dropdown-toggle active"
                                                : "nav-link dropdown-toggle"
                                        }
                                        id="projectDropdown"
                                        role="button"
                                        data-bs-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                    >
                                        The Project <span className="caret"></span>
                                    </NavLink>
                                    <ul className="dropdown-menu" aria-labelledby="projectDropdown">
                                        <li>
                                            <NavLink className="dropdown-item" to="/about">
                                                About
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink className="dropdown-item" to="/support">
                                                Support
                                            </NavLink>
                                        </li>
                                        <li role="presentation" className="dropdown-divider"></li>
                                        <li className="dropdown-header">Collaborators</li>
                                        <li>
                                            <NavLink className="dropdown-item" to="/participants">
                                                Participants
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink className="dropdown-item" to="/affiliation">
                                                Academic Affiliations
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink className="dropdown-item" to="/partners">
                                                Corporate Partnerships
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className="nav-item dropdown">
                                    <NavLink
                                        to="/biography"
                                        className={({ isActive }) =>
                                            isActive ||
                                                window.location.pathname.includes('/biography')
                                                ? "nav-link dropdown-toggle active"
                                                : "nav-link dropdown-toggle"
                                        }
                                        data-bs-toggle="dropdown"
                                        role="button"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                    >
                                        Biography <span className="caret"></span>
                                    </NavLink>

                                    <ul className="dropdown-menu">
                                        <li>
                                            <NavLink className="dropdown-item" to="/biography?section=biography">
                                                About Charles Brockden Brown
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink className="dropdown-item" to="/biography?section=chronology">
                                                Chronology of Brown's Life
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink className="dropdown-item" to="/biography?section=correspondents">
                                                Correspondents of Brown
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li className="dropdown nav-item">
                                    <NavLink
                                        to="/archive"
                                        className={({ isActive }) =>
                                            isActive ||
                                                window.location.pathname.includes('/archive') ||
                                                window.location.pathname.includes('/bibliography') ||
                                                window.location.pathname.includes('/translations') ||
                                                window.location.pathname.includes('/loc')
                                                ? "nav-link dropdown-toggle active"
                                                : "nav-link dropdown-toggle"
                                        }
                                        data-bs-toggle="dropdown"
                                        role="button"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                    >
                                        The Archive <span className="caret"></span>
                                    </NavLink>


                                    <ul className="dropdown-menu">
                                        <li>
                                            <NavLink className="dropdown-item" to="/archive?section=access">
                                                The Archive
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink className="dropdown-item" to="/bibliography">
                                                Primary Bibliography
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink className="dropdown-item" to="/bibliography?section=removed">
                                                Primary Bib Removed Items
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink className="dropdown-item" to="/bibliography?section=secondary">
                                                Secondary Bibliography
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink className="dropdown-item" to="/translations">
                                                Translations of Writings by CBB
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink className="dropdown-item" to="/loc">
                                                Library of Congress Subject Headings
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <NavLink className="nav-link" to="/volumes">
                                        Scholarly Edition
                                    </NavLink>
                                </li>
                                <li className="dropdown nav-item">
                                    <NavLink
                                        to="/teaching-resources"
                                        className={({ isActive }) =>
                                            isActive ||
                                                window.location.pathname.includes('/summaries') ||
                                                window.location.pathname.includes('/editions')
                                                ? "nav-link dropdown-toggle active"
                                                : "nav-link dropdown-toggle"
                                        }
                                        data-bs-toggle="dropdown"
                                        role="button"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                    >
                                        Teaching Resources <span className="caret"></span>
                                    </NavLink>

                                    <ul className="dropdown-menu">
                                        <li>
                                            <NavLink className="dropdown-item" to="/summaries">
                                                Abstracts of Publications
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink className="dropdown-item" to="/editions">
                                                Classroom Editions
                                            </NavLink>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <a
                                        className="nav-link"
                                        href="https://brockdenbrownsociety.cah.ucf.edu/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Brown Society
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
            )}
            <div className="row search-bar">
                {isSearchResultsPage && (
                    <div className="col search-info">
                        <span className="search-term">
                            <strong>Search:</strong> {getSearchDescription(params)}
                        </span>
                    </div>
                )}
                {isSearchResultsPage && (
                    <div className="col search-links">
                        <button className="search-link" onClick={handleNewSearch}>
                            New Search
                        </button>
                        <button className="search-link" onClick={handleModifySearch}>
                            Modify Search
                        </button>
                    </div>
                )}
            </div>
            <div className="row search-bar">
                {isSearchResultsPage && (
                    <div className="col search-info">
                        <span className="results-count">
                            <strong>Results:</strong>{" "}
                            {numResults === null
                                ? "Loading..."
                                : `${numResults} Item${numResults === 1 ? "" : "s"}`}
                        </span>
                    </div>
                )}
                <div className="col search-info">
                    {isViewDocumentPage && (
                        <button
                            className="search-link"
                            onClick={() => {
                                const citationWindow = window.open('', '_blank', 'width=780,height=400');
                                if (citationWindow) {
                                    citationWindow.document.title = "Citation";

                                    const citationContent = `
                                    <html>
                                        <head>
                                        <title>Citation</title>
                                        <style>
                                            body {
                                            margin: 0;
                                            padding: 0;
                                            font-family: sans-serif;
                                            }
                                            .header-image img {
                                            display: block;
                                            width: 780px;
                                            height: 84px;
                                            }
                                            .citation-content {
                                            padding: 20px;
                                            }
                                        </style>
                                        </head>
                                        <body>
                                        <div class="header-image">
                                            <img
                                            src="${process.env.PUBLIC_URL}/images/header/logo_brockden.jpg"
                                            alt="Charles Brockden Brown Archive Header"
                                            />
                                        </div>
                                        <div class="citation-content">
                                            <h2>Citation</h2>
                                            <p>${builtCitationContent}</p>
                                            <p><small>${window.location.href}</small></p>
                                            <a href="#" onclick="window.close()">Close this Window</a>
                                        </div>
                                        </body>
                                    </html>
                                    `;
                                    citationWindow.document.open();
                                    citationWindow.document.write(citationContent);
                                    citationWindow.document.close();
                                }
                            }}
                        >
                            View Citation
                        </button>
                    )}
                    {isViewDocumentPage && (
                        <button
                            className="search-link"
                            onClick={() => {
                                if (!isDocumentLoaded) return;

                                const rightPane = document.querySelector('.right-pane');
                                if (!rightPane) return;

                                const printWindow = window.open('', '_blank');
                                if (!printWindow) return;

                                const { document: printDoc } = printWindow;

                                // Start building a new HTML skeleton
                                const html = printDoc.createElement('html');
                                const head = printDoc.createElement('head');
                                const title = printDoc.createElement('title');
                                title.textContent = 'Print View';
                                head.appendChild(title);

                                // Clone all <link> and <style> elements from current head
                                document.querySelectorAll('link[rel="stylesheet"], style').forEach((el) => {
                                    head.appendChild(el.cloneNode(true));
                                });

                                // Build body
                                const body = printDoc.createElement('body');
                                const content = printDoc.createElement('div');
                                content.className = 'teiContainer';
                                content.innerHTML = rightPane.innerHTML;

                                // Fix image srcs
                                const imgs = content.querySelectorAll('img');
                                imgs.forEach(img => {
                                    const src = img.getAttribute('src');
                                    if (src && src.startsWith('/')) {
                                        img.src = window.location.origin + src;
                                    }
                                });

                                // Fix anchor hrefs
                                const anchors = content.querySelectorAll('a[href]');
                                anchors.forEach(a => {
                                    const href = a.getAttribute('href');
                                    if (href && href.startsWith('/')) {
                                        a.href = window.location.origin + href;
                                    }
                                });

                                body.appendChild(content);

                                html.appendChild(head);
                                html.appendChild(body);

                                // Replace the print window's entire document
                                printDoc.replaceChild(html, printDoc.documentElement);
                            }}
                            disabled={!isDocumentLoaded}
                        >
                            Print View
                        </button>
                    )}
                </div>
                {(isViewDocumentPage || !isSearchResultsPage) && (
                    <div className="col search-links">
                        <button className="search-link" onClick={handleNewSearch}>
                            New Search
                        </button>
                        <button className="search-link" onClick={handleModifySearch}>
                            Modify Search
                        </button>
                    </div>
                )}
                {isSearchResultsPage && (
                    <div className="col search-links browse-buttons">
                        <strong style={{ color: "white" }}>Browse by: </strong>
                        <button className="search-link" onClick={handleBrowseChronological}>Chronological Order</button>
                        <strong style={{ color: 'white' }}> | </strong>
                        <button className="search-link" onClick={handleBrowseTitle}>Title</button>
                    </div>
                )}
            </div>
            {isSearchResultsPage && (
                <div className="row search-bar">
                    <div className="col search-info">
                        <label htmlFor="sortDropdown"><strong>Sort By:</strong></label>
                        <select id="sortDropdown" value={sortOption} onChange={handleSortChange}>
                            <option value="relevance">Relevance</option>
                            <option value="title">Title</option>
                            <option value="accession">Accession</option>
                            <option value="author">Author</option>
                            <option value="genre">Genre</option>
                            <option value="date">Date</option>
                            <option value="reverseDate">Reverse Date</option>
                        </select>
                        <button className="" onClick={handleApplySort}>Go!</button>
                    </div>

                    <div className="col search-links browse-buttons" style={{ textAlign: 'right' }}>
                        {processedMetadata.length > 0 && (
                            <>
                                <strong style={{ color: 'white' }}>Page:</strong>{' '}
                                <button
                                    className="search-link"
                                    disabled={currentPage === 1}
                                    onClick={() => setCurrentPage(p => p - 1)}
                                    style={{ opacity: currentPage === 1 ? 0.5 : 1, pointerEvents: currentPage === 1 ? 'none' : 'auto' }}
                                >
                                    Prev
                                </button>

                                {startPage > 1 && (
                                    <button className="search-link" onClick={goToPrevGroup}>
                                        ...
                                    </button>
                                )}
                                {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map(pageNum => (
                                    <button
                                        key={pageNum}
                                        className={`search-link ${pageNum === currentPage ? 'active-page' : ''}`}
                                        style={{
                                            fontWeight: pageNum === currentPage ? 'bold' : 'normal',
                                        }}
                                        onClick={() => setCurrentPage(pageNum)}
                                    >
                                        {pageNum}
                                    </button>
                                ))}

                                {endPage < totalPages && (
                                    <button className="search-link" onClick={goToNextGroup}>
                                        ...
                                    </button>
                                )}

                                <button
                                    className="search-link"
                                    disabled={currentPage === totalPages}
                                    onClick={() => setCurrentPage(p => p + 1)}
                                    style={{ opacity: currentPage === totalPages ? 0.5 : 1, pointerEvents: currentPage === totalPages ? 'none' : 'auto' }}
                                >
                                    Next
                                </button>
                            </>
                        )}
                    </div>
                </div>
            )}
        </>
    );
}

export default Navbar;
